/**
 * @module handler
 */

/**
 * @ignore
 */
const isErrorStatus = (response: Response) => (
	response.status >= 400 &&
	response.status < 500
);

export interface HandleResponseOptions<T> {
	formatter: (response: Response) => Promise<T>;
}

/**
 * handler for fetch api.
 * @param response response of fetch api.
 * @param type content-type.
 */
export function handleResponse<T = any>(
	response: Response,
	options: HandleResponseOptions<T> = {
		formatter: res => res.json(),
	}
): Promise<T> {
	if (!response) {
		throw new Error();
	}

	if (isErrorStatus(response)) {
		return options.formatter(response).then((res) => Promise.reject(res));
	}

	return options.formatter(response);
}
